/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineResponse20020
 */
export interface InlineResponse20020 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20020
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20020
     */
    updatedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    gameId?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineResponse20020
     */
    events?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    devourGameLogo?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    bannerImageSmall?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    bannerImageLarge?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    landingImageSmall?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    landingImageLarge?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    timeRewardImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20020
     */
    isEventSupported?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20020
     */
    isEventSupportReady?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20020
     */
    hasUserStats?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20020
     */
    steamAppId?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    steamName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20020
     */
    timeTrackedGame?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    shortDescription?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineResponse20020
     */
    genres?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineResponse20020
     */
    developers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineResponse20020
     */
    publishers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    releaseDate?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    steamHeaderImage?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    steamCapsuleImage?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    steamBackground?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineResponse20020
     */
    steamScreenshots?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineResponse20020
     */
    categories?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20020
     */
    recommendations?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20020
     */
    achievements?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    website?: string;
}

export function InlineResponse20020FromJSON(json: any): InlineResponse20020 {
    return InlineResponse20020FromJSONTyped(json, false);
}

export function InlineResponse20020FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20020 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'gameId': !exists(json, 'gameId') ? undefined : json['gameId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'events': !exists(json, 'events') ? undefined : json['events'],
        'logo': !exists(json, 'logo') ? undefined : json['logo'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'devourGameLogo': !exists(json, 'devourGameLogo') ? undefined : json['devourGameLogo'],
        'bannerImageSmall': !exists(json, 'bannerImageSmall') ? undefined : json['bannerImageSmall'],
        'bannerImageLarge': !exists(json, 'bannerImageLarge') ? undefined : json['bannerImageLarge'],
        'landingImageSmall': !exists(json, 'landingImageSmall') ? undefined : json['landingImageSmall'],
        'landingImageLarge': !exists(json, 'landingImageLarge') ? undefined : json['landingImageLarge'],
        'thumbnailImage': !exists(json, 'thumbnailImage') ? undefined : json['thumbnailImage'],
        'timeRewardImage': !exists(json, 'timeRewardImage') ? undefined : json['timeRewardImage'],
        'isEventSupported': !exists(json, 'isEventSupported') ? undefined : json['isEventSupported'],
        'isEventSupportReady': !exists(json, 'isEventSupportReady') ? undefined : json['isEventSupportReady'],
        'hasUserStats': !exists(json, 'hasUserStats') ? undefined : json['hasUserStats'],
        'steamAppId': !exists(json, 'steamAppId') ? undefined : json['steamAppId'],
        'steamName': !exists(json, 'steamName') ? undefined : json['steamName'],
        'timeTrackedGame': !exists(json, 'timeTrackedGame') ? undefined : json['timeTrackedGame'],
        'shortDescription': !exists(json, 'shortDescription') ? undefined : json['shortDescription'],
        'genres': !exists(json, 'genres') ? undefined : json['genres'],
        'developers': !exists(json, 'developers') ? undefined : json['developers'],
        'publishers': !exists(json, 'publishers') ? undefined : json['publishers'],
        'releaseDate': !exists(json, 'releaseDate') ? undefined : json['releaseDate'],
        'steamHeaderImage': !exists(json, 'steamHeaderImage') ? undefined : json['steamHeaderImage'],
        'steamCapsuleImage': !exists(json, 'steamCapsuleImage') ? undefined : json['steamCapsuleImage'],
        'steamBackground': !exists(json, 'steamBackground') ? undefined : json['steamBackground'],
        'steamScreenshots': !exists(json, 'steamScreenshots') ? undefined : json['steamScreenshots'],
        'categories': !exists(json, 'categories') ? undefined : json['categories'],
        'recommendations': !exists(json, 'recommendations') ? undefined : json['recommendations'],
        'achievements': !exists(json, 'achievements') ? undefined : json['achievements'],
        'website': !exists(json, 'website') ? undefined : json['website'],
    };
}

export function InlineResponse20020ToJSON(value?: InlineResponse20020 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'gameId': value.gameId,
        'name': value.name,
        'description': value.description,
        'events': value.events,
        'logo': value.logo,
        'icon': value.icon,
        'devourGameLogo': value.devourGameLogo,
        'bannerImageSmall': value.bannerImageSmall,
        'bannerImageLarge': value.bannerImageLarge,
        'landingImageSmall': value.landingImageSmall,
        'landingImageLarge': value.landingImageLarge,
        'thumbnailImage': value.thumbnailImage,
        'timeRewardImage': value.timeRewardImage,
        'isEventSupported': value.isEventSupported,
        'isEventSupportReady': value.isEventSupportReady,
        'hasUserStats': value.hasUserStats,
        'steamAppId': value.steamAppId,
        'steamName': value.steamName,
        'timeTrackedGame': value.timeTrackedGame,
        'shortDescription': value.shortDescription,
        'genres': value.genres,
        'developers': value.developers,
        'publishers': value.publishers,
        'releaseDate': value.releaseDate,
        'steamHeaderImage': value.steamHeaderImage,
        'steamCapsuleImage': value.steamCapsuleImage,
        'steamBackground': value.steamBackground,
        'steamScreenshots': value.steamScreenshots,
        'categories': value.categories,
        'recommendations': value.recommendations,
        'achievements': value.achievements,
        'website': value.website,
    };
}


